import { Typography } from '@mui/material';
import { PropsWithChildren } from 'react';

export function TableTypography({ children }: PropsWithChildren<{}>) {
  return <Typography variant='body2'>{children}</Typography>;
}
